const NOTEPAD_VERSION = "1.0.0";

export { NOTEPAD_VERSION };
//# sourceMappingURL=tiptap.config.js.map
